module.exports = {
          srcSet: "/_next/static/images/home-teaser1-260-6ef858e92e4c2935996e4f9544f50bf5.jpg"+" 260w",
          images:[ {path: "/_next/static/images/home-teaser1-260-6ef858e92e4c2935996e4f9544f50bf5.jpg",width: 260,height: 260}],
          src: "/_next/static/images/home-teaser1-260-6ef858e92e4c2935996e4f9544f50bf5.jpg",
          toString:function(){return "/_next/static/images/home-teaser1-260-6ef858e92e4c2935996e4f9544f50bf5.jpg"},
          
          width: 260,
          height: 260
        }